export default __webpack_public_path__ + "static/media/trustpilot-logo.88390597.svg";